import { Component, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Company } from '@app/models/company/company.model';
import { Office } from '@app/models/company/office.model';
import { OnboardingStatusService } from '@app/modules/self-serve/services/onboarding-status.service';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
import { AnalyticEvents } from '@app/enums';
import { filter } from 'rxjs/operators';

@Component({
    templateUrl: './add-company-info.template.html',
    styleUrls: ['../../../self-serve.style.scss'],
})
export class AddCompanyInfoView implements OnInit {
    @ViewChild('form', { static: true }) form!: NgForm;
    isLoading = true;
    isSaving = false;
    company: Company = new Company();
    office: Office = new Office();
    showIWillDoItLater = false;

    constructor(
        private analyticService: AnalyticService,
        private router: Router,
        private authService: AuthService,
        private onboardingStatusService: OnboardingStatusService,
        private notifyService: NotifyService
    ) {
        this.onboardingStatusService.onboardingStatus$
            .pipe(
                filter((onboardingStatus) => onboardingStatus !== null),
                takeUntilDestroyed()
            )
            .subscribe((onboardingStatus) => {
                this.showIWillDoItLater = !onboardingStatus?.companyDetails.steps.addCompanyInfo;
            });
    }

    async ngOnInit(): Promise<void> {
        try {
            this.company = await Company.find(this.authService.company.id);

            if (this.company.primaryAddressId) {
                this.office = await Office.param('company', this.company.id).find(this.company.primaryAddressId);
            }

            this.office.param('company', this.company.id);
        } catch (error) {
            this.notifyService.error(error);
        } finally {
            this.isLoading = false;
        }
    }

    async onSubmit(): Promise<void> {
        if (!this.form.valid || this.isSaving) {
            return;
        }

        try {
            this.isSaving = true;
            await this.company.save();
            await this.office.save();
            this.onboardingStatusService.refresh();

            this.analyticService.trackEvent(AnalyticEvents.SelfServeAddCompanyDetailsClickSave);

            this.next();
        } catch (error) {
            this.notifyService.error(error);
            this.isSaving = false;
        }
    }

    next(): void {
        this.router.navigate(['/company-onboarding']);
    }
}
